export default __webpack_public_path__ + "static/media/28.c331ea17.JPG";